module.exports = __webpack_public_path__ + "img/alipay.fc11a05d.svg";